/**
 * API errors in words a partner can act on. One table, so the same failure
 * reads the same in a toast, a form and the sign-in page.
 */
import { ApiError } from '@/api/client'

const BY_CODE: Record<string, { title: string; description?: string }> = {
  coupon_code_taken: { title: 'That code is already taken', description: 'Codes are unique across all partners. Try another word, or use Suggest for a free one.' },
  discount_above_max: { title: 'That discount is above your maximum', description: 'Lower the discount, or ask your JobSlide contact to raise your maximum.' },
  partner_suspended: { title: 'Your partner account is suspended', description: 'Your coupons are paused. Ask your JobSlide contact to reactivate it.' },
  invalid_credentials: { title: 'That email and password do not match' },
  wrong_password: { title: 'Your current password is not right', description: 'Check it and try again.' },
  billing_not_configured: { title: 'Discount codes are not switched on yet', description: 'Payments are not set up here, so a code with a discount cannot be activated. A 0% code works now.' },
  too_many_attempts: { title: 'Too many attempts', description: 'Wait a few minutes, then try again.' },
  rate_limited: { title: 'Too many attempts', description: 'Wait a few minutes, then try again.' },
  network_error: { title: 'Could not reach JobSlide', description: 'Check your connection and try again.' },
  coupon_expired: { title: 'That code has expired', description: 'Set a later expiry date, or create a new code.' },
  coupon_locked: { title: 'This coupon is locked', description: 'Its discount and duration cannot change after activation. Create a new code instead.' },
  not_found: { title: 'Not found', description: 'It may have been removed. Refresh the page.' },
}

export function describeError(error: unknown, fallback = 'Something went wrong'): { title: string; description?: string } {
  if (!(error instanceof ApiError)) return { title: fallback, description: error instanceof Error ? error.message : undefined }
  const known = BY_CODE[error.code]
  if (known) return known
  if (error.status === 401) return { title: 'Your session has ended', description: 'Sign in again to continue.' }
  if (error.status === 429) return BY_CODE.rate_limited!
  if (error.status >= 500) return { title: 'JobSlide had a problem', description: 'Nothing was changed. Try again in a minute.' }
  const firstField = Object.values(error.fieldErrors)[0]
  return { title: error.problem?.title && error.status !== 422 ? error.problem.title : fallback, description: firstField ?? error.message }
}
